"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.min = exports.max = exports.distinctItem = exports.distinct = exports.avg = exports.sum = void 0;
/**
 * sumuje wartości w tablicy
 * @param array tablica do sumowania
 * @param prop pole w wierszu podlegające sumowaniu, można pominąć
 */
function sum(array, prop) {
    //const $result = 0;
    if (prop) {
        if (typeof prop === 'string') {
            var res = 0;
            for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
                var item = array_1[_i];
                res += item[prop];
            }
            return res;
            //return array.reduce((partialSum, a) => partialSum + (a as any)[prop], 0);
        }
        else {
            return array.reduce(function (partialSum, a, index) {
                var v = prop(a, index);
                if (v !== undefined) {
                    return partialSum + prop(a, index);
                }
                else {
                    return partialSum;
                }
            }, 0);
        }
    }
    else {
        return array.reduce(function (partialSum, a) { return partialSum + a; }, 0);
    }
}
exports.sum = sum;
/**
 * średnia wartośc z tablicy
 * @param array tablica do sumowania
 * @param prop pole w wierszu podlegające sumowaniu, można pominąć
 */
function avg(array, prop) {
    if (prop) {
        if (typeof prop === 'string') {
            return array.length === 0 ? 0 : sum(array, prop) / array.length;
        }
        else {
            var count_1 = 0;
            var ss = array.reduce(function (partialSum, a, index) {
                var v = prop(a, index);
                if (v !== undefined) {
                    count_1++;
                    return partialSum + prop(a, index);
                }
                else {
                    return partialSum;
                }
            }, 0);
            return count_1 == 0 ? 0 : ss / count_1;
        }
    }
    else {
        return array.length === 0 ? 0 : sum(array, prop) / array.length;
    }
    // return array.length === 0 ? 0 : sum(array, prop) / array.length;
}
exports.avg = avg;
/**
 * unikalne wartości z tablicy
 * @param array tablica do sumowania
 * @param prop zwracane pole z wiersza tablicy
 */
function distinct(array, prop) {
    var $result = [];
    var $distinct = {};
    if (prop) {
        var isString = typeof prop === 'string';
        for (var i = 0; i < array.length; i++) {
            var $v = isString ? array[i][prop] : prop(array[i], i);
            if ($v !== undefined && $distinct[$v] === undefined) {
                $result.push($v);
                $distinct[$v] = i;
            }
        }
    }
    else {
        for (var i = 0; i < array.length; i++) {
            if ($distinct[array[i]] === undefined) {
                $result.push(array[i]);
                $distinct[array[i]] = i;
            }
        }
    }
    return $result;
}
exports.distinct = distinct;
/**
 * unikalne wiersze z tablicy
 * @param array tablica do sumowania
 * @param prop pole do określenia unikalności wiersza
 */
function distinctItem(array, prop) {
    var $result = [];
    var $distinct = {};
    if (prop) {
        var isString = typeof prop === 'string';
        for (var i = 0; i < array.length; i++) {
            var $v = isString ? array[i][prop] : prop(array[i], i);
            if ($v !== undefined && $distinct[$v] === undefined) {
                $result.push(array[i]);
                $distinct[$v] = i;
            }
        }
    }
    else {
        for (var i = 0; i < array.length; i++) {
            if ($distinct[array[i]] === undefined) {
                $result.push(array[i]);
                $distinct[array[i]] = i;
            }
        }
    }
    return $result;
}
exports.distinctItem = distinctItem;
/**
 * zwraca maksymalną wartość
 * @param values tablica wartości
 * @param prop sprawdzane property
 */
function max(array, prop) {
    // let maxValue = -23432434234;
    if (array.length == 0)
        return;
    if (prop) {
        if (typeof prop === 'string') {
            array.reduce(function (partialMax, a) { return (a[prop] > partialMax ? a[prop] : partialMax); }, array[0][prop]);
        }
        else {
            return array.reduce(function (partialMax, a, index) {
                var v = prop(a, index);
                if (v !== undefined && (partialMax == undefined || v > partialMax))
                    return v;
                return partialMax;
                //prop(a, index) > partialMax ? prop(a, index) : partialMax, prop(array[0], 0)
            }, undefined);
        }
    }
    else {
        return array.reduce(function (partialMax, a) { return (a > partialMax ? a : partialMax); }, array[0]);
    }
}
exports.max = max;
/**
 * zwraca minimalną wartość
 * @param values tablica wartości
 * @param prop sprawdzane property
 */
function min(array, prop) {
    if (array.length == 0)
        return;
    if (prop) {
        if (typeof prop === 'string') {
            array.reduce(function (partialMin, a) { return (a[prop] < partialMin ? a[prop] : partialMin); }, array[0][prop]);
        }
        else {
            return array.reduce(function (partialMin, a, index) {
                var v = prop(a, index);
                if (v !== undefined && (partialMin == undefined || v < partialMin))
                    return v;
                return partialMin;
            }, undefined);
            //return array.reduce((partialMin, a, index) => prop(a, index) < partialMin ? prop(a, index) : partialMin, prop(array[0], 0))
        }
    }
    else {
        return array.reduce(function (partialMin, a) { return (a < partialMin ? a : partialMin); }, array[0]);
    }
}
exports.min = min;
//# sourceMappingURL=aggreagate.js.map